import { z } from "zod/v4";

import { ScheduleDtoSchema } from "../../dtos/schedule";

export const GetSchedulesByExperienceIdPathParamSchema = z.object({
  experienceId: z.uuid(),
});

export type GetSchedulesByExperienceIdPathParamType = z.infer<
  typeof GetSchedulesByExperienceIdPathParamSchema
>;

export const GetSchedulesByExperienceIdResponseBodySchema = z.object({
  schedules: ScheduleDtoSchema.array(),
});

export type GetSchedulesByExperienceIdResponseBodyType = z.infer<
  typeof GetSchedulesByExperienceIdResponseBodySchema
>;
